import { NgModule } from '@angular/core';
import { PhxMiddleTruncateDirective } from './phx-middle-truncate.directive';

@NgModule({
  declarations: [PhxMiddleTruncateDirective],
  exports: [PhxMiddleTruncateDirective],
})
export class PhxMiddleTruncateModule {}
